<template>
  <section class="app-main">
    <el-tabs type="border-card" v-model="tab">
      <el-tab-pane name="info" label="修改商品基本信息">
        <el-card class="m-bottom-4">
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 商品语言： </el-col>
            <el-col :span="22">
              <el-radio
                v-model="goods.language"
                @change="getDetail($route.params.id)"
                label="zh"
                border
                style="width: 130px"
                >中文录入</el-radio
              >
              <el-radio
                v-model="goods.language"
                @change="getDetail($route.params.id)"
                label="en"
                border
                style="width: 130px"
                >英文录入</el-radio
              >
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 商品类型： </el-col>
            <el-col :span="22">
              <el-radio
                v-model="goods.goods_type"
                label="1"
                border
                style="width: 130px"
                >普通商品</el-radio
              >
              <el-radio
                v-model="goods.goods_type"
                label="2"
                border
                style="width: 130px"
                >食品类型</el-radio
              >
              <el-radio
                v-model="goods.goods_type"
                label="3"
                border
                style="width: 130px"
                >服务类型</el-radio
              >
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 税费类型： </el-col>
            <el-col :span="22">
              <el-radio
                v-model="goods.tax_type"
                label="1"
                border
                style="width: 130px"
                >收税</el-radio
              >
              <el-radio
                v-model="goods.tax_type"
                label="2"
                border
                style="width: 130px"
                >免税</el-radio
              >
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 商品名称： </el-col>
            <el-col :span="22">
              <el-input
                v-model="goods.name"
                placeholder="请输入商品名称"
                style="width: 400px"
              ></el-input>
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 关联词语： </el-col>
            <el-col :span="22">
              <el-input
                v-model="goods.description"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 6 }"
                placeholder="请输入商品关联词语(逗号隔开)"
                style="width: 100%"
              ></el-input>
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 商品分类： </el-col>
            <el-col :span="22">
              <el-select
                v-model="goods.type_id"
                filterable
                multiple
                placeholder="请选择"
                style="width: 400px"
              >
                <el-option
                  v-for="it in classifyOptions"
                  :key="it.id"
                  :label="goods.language == 'zh' ? it.title : it.title_en"
                  :value="it.id"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-card>

        <el-card class="m-bottom-4">
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 商品主图： </el-col>
            <el-col :span="22">
              <m-upload
                :img.sync="image"
                :width="120"
                :height="120"
                file-name="goodsImg"
                placement="right"
              />
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 图片要求： </el-col>
            <el-col :span="22" class="input-left tips">
              仅接受JPG、JPEG、PNG格式，200*200
            </el-col>
          </el-row>
        </el-card>

        <el-card class="m-bottom-4">
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 商品视频： </el-col>
            <el-col :span="22">
              <m-video
                :video.sync="video"
                :width="120"
                :height="120"
                file-name="goodsVideo"
              ></m-video>
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 视频要求： </el-col>
            <el-col :span="22" class="input-left tips">
              （可不上传）仅接受MP4格式，375*375
            </el-col>
          </el-row>
        </el-card>

        <el-card class="m-bottom-4">
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 轮播图： </el-col>
            <el-col :span="22">
              <m-uploads
                :imgs.sync="banner"
                :width="120"
                :height="120"
                file-name="goodsBanner"
              ></m-uploads>
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 图片要求： </el-col>
            <el-col :span="22" class="input-left tips">
              仅接受JPG、JPEG、PNG格式，375*375
            </el-col>
          </el-row>
        </el-card>

        <el-card class="m-bottom-4">
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 详情图： </el-col>
            <el-col :span="22">
              <m-uploads
                :imgs.sync="details"
                :width="120"
                :height="120"
                file-name="goodsDetails"
              ></m-uploads>
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 图片要求： </el-col>
            <el-col :span="22" class="input-left tips">
              仅接受JPG、JPEG、PNG格式，375*375
            </el-col>
          </el-row>
        </el-card>

        <el-card class="m-bottom-4">
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 售后服务： </el-col>
            <el-col :span="22">
              <el-radio
                v-model="goods.after_sale"
                :label="1"
                border
                style="width: 130px"
                >七天无理由</el-radio
              >
              <el-radio
                v-model="goods.after_sale"
                :label="2"
                border
                style="width: 180px"
                >非质量问题不退不换</el-radio
              >
              <el-radio
                v-model="goods.after_sale"
                :label="3"
                border
                style="width: 180px"
                >商品售出不退不换</el-radio
              >
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 售后说明： </el-col>
            <el-col :span="22" class="input-left tips">
              <el-input
                v-model="goods.after_sale_content"
                placeholder="请输入售后说明"
                style="width: 570px"
              ></el-input>
            </el-col>
          </el-row>
        </el-card>

        <el-card>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 提交修改： </el-col>
            <el-col :span="22">
              <el-button
                @click="handleSubmit()"
                type="success"
                plain
                style="width: 150px"
                >确认修改</el-button
              >
            </el-col>
          </el-row>
        </el-card>
      </el-tab-pane>

      <el-tab-pane name="sku" label="修改商品SKU">
        <el-card class="m-bottom-4" style="overflow-y: auto">
          <div style="border: 1px solid #dddfe1;padding-left:5px;">
            <el-row class="m-padding-1">
                <el-col :span="2" class="input-left">
                    商品语言：
                </el-col>
                <el-col :span="22">
                    <el-radio v-model="language" label="zh" border style="width:150px;margin-right:10px">中文规格</el-radio>
                    <el-radio v-model="language" label="en" border style="width:150px">英文规格</el-radio>
                </el-col>
            </el-row> 
            <div v-for="(it,i) in sku" :key="i">
              <el-row class="m-padding-1" style="background: #f5f7fa;">
                <el-col :span="2" class="input-left">商品规格：</el-col>
                <el-col :span="22">
                  <el-input v-if="language == 'zh'" v-model="it.title"  placeholder="输入属性名称" class="sku-input" disabled></el-input>
                  <el-input v-else v-model="it.title_en"  placeholder="输入属性名称" class="sku-input" disabled></el-input>
                </el-col>
              </el-row>
              <el-row class="m-padding-1">
                <el-col :span="2" class="input-left"> 规格属性：</el-col>
                <el-col :span="22" v-if="language == 'zh'">
                  <el-input v-for="(item,index) in it.attr_val" :key="index" v-model="item.attr_title"  placeholder="输入属性名称" class="sku-input" style="margin-bottom:10px;" @keyup.enter.native="attrUpdate(item)" @change="attrUpdate(item)">
                    <i @click="skuReduce(item,i,index)" slot="prefix" class="el-input__icon el-icon-delete"></i>
                  </el-input>
                  <el-button plain class="sku-add" @click="handleValueAdd(it,i)">添加属性</el-button>
                </el-col>
                <el-col :span="22" v-else>
                  <el-input  v-for="(item,index) in it.attr_val" :key="index" v-model="item.attr_title_en"  placeholder="输入属性名称" class="sku-input" style="margin-bottom:10px;" @keyup.enter.native="attrUpdate(item)" @change="attrUpdate(item)">
                    <!-- <i @click="skuReduce(item)" slot="prefix" class="el-input__icon el-icon-delete"></i> -->
                  </el-input>
                  <!-- <el-button plain class="sku-add" @click="handleValueAdd(it.id)">添加属性</el-button> -->
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="">
            <el-row class="m-padding-1">
                <el-col :span="1" class="input-left">
                    供应商：
                </el-col>
                <el-col :span="22" class="input-left" v-if="skuItems[0]?.supplier">
                    {{skuItems[0]?.supplier?.name}}
                </el-col>
            </el-row> 
          </div>
          <el-row v-show="skuItems.length != 0">
            <div class="sku-items-head">
              <div v-if="language == 'zh'">
                <p
                  v-for="(item, index) in skuHead"
                  :key="index"
                >
                  <span>{{ item.title  }}</span>
                </p>
              </div>
              <div v-else>
                <p
                  v-for="(item, index) in skuHead"
                  :key="index"
                >
                  <span>{{ item.title_en }}</span>
                </p>
              </div>
              <div class="m-width-100"><span>原价(C$)</span></div>
              <div class="m-width-100"><span>销售价(C$)</span></div>
              <div class="m-width-100"><span>活动价(C$)</span></div>
              <div class="m-width-100"><span>预售价(C$)</span></div>
              <div class="m-width-100"><span>代理价(C$)</span></div>
              <div class="m-width-160"><span>是否为折扣商品</span></div>
              <div class="m-width-120"><span>重量(单位kg)</span></div>
              <div class="m-width-100"><span>长(单位cm)</span></div>
              <div class="m-width-100"><span>宽(单位cm)</span></div>
              <div class="m-width-100"><span>高(单位cm)</span></div>
              <div class="m-width-165"><span>条形码</span></div>
              <div class="m-width-100"><span>变量图片</span></div>
              <div class="m-width-60"></div>
            </div>
            <div
              class="sku-items-body"
              v-for="(it, index) in skuItems"
              :key="index"
            >
              <div v-if="language == 'zh'">
                <p
                  v-for="(item, ind) in it.attr_data"
                  :key="ind"
                >
                  <el-input
                    v-model="item.attr_title"
                    size="small"
                    style="width:117px"
                    disabled
                  ></el-input>
                </p>
              </div>
              <div v-else>
                <p
                  v-for="(item, ind) in it.attr_data"
                  :key="ind"
                >
                  <el-input
                    v-model="item.attr_title_en"
                    size="small"
                    style="width:117px"
                    disabled
                  ></el-input>
                </p>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.cost_price" size="small" :disabled="it.is_off == 1 ? true : false"></el-input>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.price" size="small" :disabled="it.is_off == 1 ? true : false"></el-input>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.activity_price" size="small" disabled></el-input>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.pre_sale_price" size="small"></el-input>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.proxy_price" size="small"></el-input>
              </div>
              <div class="m-width-160">
                  {{it.is_off == 1 ? '是' : '否'}}
              </div>
              <div class="m-width-120">
                <el-input v-model="it.goods_weight" size="small"></el-input>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.goods_length" size="small"></el-input>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.goods_width" size="small"></el-input>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.goods_height" size="small"></el-input>
              </div>
              <div class="m-width-165">
                <el-input v-model="it.barcode" size="small"></el-input>
              </div>
              <div class="m-width-100" style="text-align: center">
                <m-upload
                  :img.sync="it.pic_image"
                  :width="70"
                  :height="70"
                  file-name="goodSku"
                  placement="right"
                />
              </div>
              <div class="m-width-60">
                <el-button type="danger" icon="el-icon-delete" circle @click="handleDelSku(it)"></el-button>
              </div>
            </div>
          </el-row>
          <el-button  @click="handleSkuCopy()" type="success" plain style="width:120px;margin-top:15px">一键填充</el-button>
          <div class="sku-tips">Tips：一键填充将所有新增SKU的原价、销售价、预售价、代理价、重量、长、宽、高等于第一行的数据</div>
        </el-card>
        <el-card>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 提交修改： </el-col>
            <el-col :span="22">
              <el-button @click="handleSku()" type="success" plain
                >确认修改</el-button
              >
            </el-col>
          </el-row>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </section>
</template>
<script>
import { goods_get, goods_put, goods_sku, sku_update, sku_del, attr_list,attr_add, attr_update, attr_del, classify_list} from "@/api/goods.js";
import MUpload from "@/components/m-upload.vue";
import MVideo from "@/components/m-video.vue";
import MUploads from "@/components/m-uploads.vue";
export default {
  name: "GoodsEdit",
  components: { MUpload, MUploads, MVideo },
  data() {
    return {
      tab: "info",
      image: { url: "", pic_id: "" }, // 主图
      banner: [],
      details: [],
      video: { video_pic: "", video_id: "" },
      goods: {
        name: "",
        language: "zh",
        goods_type: "1",
        tax_type: "1",
        type_id: [],
        description: "",

        after_sale: 1,
        after_sale_content: "",
      },
      classifyOptions: [],
      skuItems: [],
      skuAttr: [],
      skuHead: [],
      language: 'zh',
      specData: [],
      sku:[], 
      id: ''
    };
  },
  methods: {
    // 获取商品详情
    getDetail(id) {
      let params = {
        language: this.goods.language,
      };
      goods_get(id, params).then((res) => {
        if (res) {
          this.goods.goods_type = res.data.goods_type + "";
          this.goods.tax_type = res.data.tax_type + "";
          this.goods.name = res.data.name;
          this.goods.description = res.data.description;
          this.goods.name = res.data.name;
          this.goods.type_id = [];
          res.data.type_id.forEach((e) => {
            this.goods.type_id.push(e.type_id);
          });
          if (res.data.video_id != 0) {
            this.video = res.data.video_url;
          } else {
            this.video = { video_pic: "", video_id: "" };
          }
          this.image.url = res.data.image_url;
          this.image.pic_id = res.data.image;
          this.banner = res.data.round_pic_url;
          this.details = res.data.goods_details==""?[]:res.data.goods_details;
          this.goods.after_sale = res.data.after_sale;
          this.goods.after_sale_content = res.data.after_sale_content;
        }
      });
    },
    // 获取规格属性列表
    getAttrList() {
      attr_list(this.$route.params.id).then(res => {
        if(res) {
          this.sku = res.data
        }
      })
    },
    // 规格修改
    attrUpdate(row) {
      let params = {
          goods_id: this.$route.params.id
        }
        if(this.language == 'zh') {
          params.attr_title = row.attr_title
        } else {
          params.attr_title_en = row.attr_title_en
        }
      if(row.spec_id == '') {
        params.spec_id = this.id
        attr_add(params).then(res => {
          if(res) {
            this.$message({type:'success',message:res.msg})
            this.getSku(this.$route.params.id);
            this.getAttrList()
          }
        })
      } else {
        attr_update(row.symbol,params).then(res => {
          if(res) {
            this.$message({type:'success',message:res.msg})
            this.getAttrList()
            this.getSku(this.$route.params.id);
          }
        })
      }
      
    },
     // 添加规格的属性
    handleValueAdd(el,id) {
      this.id = el.id
      let params = {
        attr_title: '',
        attr_title_en: '',
        goods_id: this.$route.params.id,
        symbol: '',
        spec_id: ''
      }
      this.sku[id].attr_val.push(params)
    },
    // 删除规格属性
    skuReduce(row,id,i) {
      if(row.spec_id == '') {
        this.sku[id].attr_val.splice(i,1)
        return false
      }
      if(row.attr_title == null) {
        row.attr_title = ''
      }
      if(row.attr_title_en == null) {
        row.attr_title_en = ''
      }
      this.$confirm(
        `此操作将删除规格属性“${this.language == 'zh' ? row.attr_title : row.attr_title_en}”, 是否继续?`,
        "提示",
        { type: "warning" }
      )
        .then(() => {
          attr_del(row.symbol).then((res) => {
            if (res) {
              this.$message({type: "success",message: res.msg});
              this.getSku(this.$route.params.id);
              this.getAttrList()
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 获取SKU信息
    getSku(id) {
      goods_sku(id).then((res) => {
        if (res) {
          this.skuItems = res.data;
          this.skuHead = []
          if (res.data[0].attr_data) {
            res.data[0].attr_data.forEach((e) => {
              this.skuHead.push(e.spec_value);
            });
          }
          this.skuItems.forEach(item => {
            item.pic_image = {
              url: item.sku_pic_url,
              pic_id: item.sku_pic
            }
          })
        }
      });
    },
    // 删除SKU
    handleDelSku(row) {
      this.$confirm(
        `此操作将删除SKU, 是否继续?`,
        "提示",
        { type: "warning" }
      ).then(() => {
          sku_del(row.id).then(res => {
            if(res) {
              this.$message({type: "success",message: res.msg});
              this.getSku(this.$route.params.id);
              this.getAttrList()
            }
        })
      })
      
    },
    // 一键填充
    handleSkuCopy() {
      let len = this.skuItems.length
      for(let i=1; i<len; i++ ) {
        if(this.skuItems[i].barcode == 0) {
          this.skuItems[i].cost_price     = this.skuItems[0].cost_price
          this.skuItems[i].price          = this.skuItems[0].price
          this.skuItems[i].pre_sale_price = this.skuItems[0].pre_sale_price
          this.skuItems[i].proxy_price    = this.skuItems[0].proxy_price
          this.skuItems[i].goods_weight   = this.skuItems[0].goods_weight
          this.skuItems[i].goods_length   = this.skuItems[0].goods_length
          this.skuItems[i].goods_width    = this.skuItems[0].goods_width
          this.skuItems[i].goods_height   = this.skuItems[0].goods_height
        }
      }
    },
    // 获取分类数据
    getClassify() {
      let params = {
        level: 2,
      };
      classify_list(params).then((res) => {
        if (res) {
          this.classifyOptions = res.data;
        }
      });
    },
    // 基础信息 确定修改
    handleSubmit() {
      let banner = [];
      this.banner.forEach((e) => {
        banner.push(e.pic_id);
      });
      let details = [];
      this.details.forEach((e) => {
        details.push(e.pic_id);
      });

      let params = {
        name: this.goods.name,
        language: this.goods.language,
        goods_details: details.join(","),
        goods_type: this.goods.goods_type,
        tax_type: this.goods.tax_type,
        type_id: this.goods.type_id.join(","),
        description: this.goods.description,
        image: this.image.pic_id,
        round_pic: banner.join(","),
        merchant_id: 1,
        after_sale: this.goods.after_sale,
        after_sale_content: this.goods.after_sale_content,
      };

      if (this.video.video_id && this.video.video_id != "") {
        params.video_id = this.video.video_id;
      } else {
        params.video_id = 0;
      }
      if (this.goods.type_id.length == 0) {
        this.$message.error("至少选择一个商品分类");
        return false;
      }
      if (this.image.pic_id == "") {
        this.$message.error("请先完善商品主图");
        return false;
      }
      if (banner.length == 0) {
        this.$message.error("至少上传一轮播图");
        return false;
      }
      goods_put(this.$route.params.id, params).then((res) => {
        if (res) {
          this.$message({ type: "success", message: res.msg, duration: 1500 });
          this.$router.go(-1);
        }
      });
    },
    handleSku() {
      let skuBol = false;
      this.skuItems.forEach((params) => {
        if(params.pic_image) {
          params.sku_pic = params.pic_image.pic_id
          params.sku_pic_url = params.pic_image.url
        }
        if(params.sku_stock == null) {
          delete params.sku_stock
        }
        if(params.attr_symbol_string_en == '' || params.attr_symbol_string_en == null) {
          delete params.attr_symbol_string_en
        }
        delete params.pic_image
        delete params.supplier
        for (let key in params) {
          // console.log(params)
          if (
            params[key] === "" ||
            params[key] === undefined ||
            params[key] === null ||
            params[key].length == 0 ||
            params[key].pic_id == ""
          ) {
            skuBol = true; // 终止程序
          }
        }
      });
      if (skuBol) {
        this.$message.error("请务必完善SKU每条信息");
        return false;
      }

      sku_update(this.$route.params.id,this.skuItems).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.$router.go(-1);
            },
          });
        }
      });
    },
  },
  created() {
    this.getClassify();
    this.getDetail(this.$route.params.id);
    this.getSku(this.$route.params.id);
    this.getAttrList()
  },
  activated() {
    this.language = 'zh'
    this.getDetail(this.$route.params.id);
    this.getSku(this.$route.params.id);
    this.getAttrList()
  }
};
</script>
<style lang="less" scoped>
.sizing {
  box-sizing: border-box;
}
section {
  .input-left {
    height: 40px;
    line-height: 40px;
    min-width: 80px;
  }
  .tips {
    color: #909399;
    font-size: 14px;
  }
  .sku-value {
    height: 40px;
    line-height: 40px;
    margin: 20px 15px 0 0;
  }
  .sku-input {
    width: 150px;
    margin-right: 20px;
  }
  .m-width-60 {
    width: 60px;
  }
  .m-width-100 {
    width: 100px;
  }
  .m-width-120 {
    width: 120px;
  }
  .m-width-140 {
    width: 140px;
  }
  .m-width-160 {
    width: 160px;
  }
  .m-width-165 {
    width: 165px;
  }
  .sku-items-head {
    min-width: 1305px;
    display: flex;
    background: #f5f7fa;
    border: 1px solid #e8e8e8;
    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
      padding: 0 8px;
      font-size: 15px;
      color: #8c939d;
      > span {
        display: inline-block;
        width: 100%;
        height: 36px;
        background: #fff;
        text-align: center;
        line-height: 36px;
        border-radius: 3px;
      }
      >p {
        width: 125px;
        text-align: center;
        >span {
          width: 117px;
          height: 36px;
          line-height: 36px;
          display: inline-block;
          background: #fff;
          border-radius: 3px;
        }
      }
    }
  }
  .sku-items-body {
    min-width: 1305px;
    display: flex;
    border: 1px solid #e8e8e8;
    border-top: none;
    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 80px;
      padding: 0 8px;
      font-size: 15px;
      color: #8c939d;
      >p {
        width: 125px;
        display: flex;
        justify-content: center;
      }
    }
    .avatar-uploader-icon {
      width: 60px;
      height: 60px;
      line-height: 60px !important;
      border: 1px solid #e0e0e0;
    }
  }
  .sku-tips {
    line-height: 30px;
    margin-top: 5px;
    color: red;
  }
  /deep/ .el-input--small .el-input__inner {
    text-align: center;
  }
}
.m-padding-1 {
  padding:10px;
}
.sku-input {
  /deep/ .el-input__inner {
    background-color:#fff;
  }
}
</style>

